"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPlayerBetStateToSerializable = void 0;
const convertPlayerBetStateToSerializable = ({ round, choice, claimed, owner, amount, }) => {
    return {
        round,
        choice,
        claimed,
        owner: owner.toBase58(),
        amount: amount.toString(),
    };
};
exports.convertPlayerBetStateToSerializable = convertPlayerBetStateToSerializable;
